export default __webpack_public_path__ + "static/media/icon-right-chevron.a998d1fe.svg";